export const styles = {
  boxStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { lg: "980px", md: "880px", sm: "92%", xs: "96%" },
    maxWidth: "1040px",
    bgcolor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.25)",
    maxHeight: "92vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    outline: "none",
  },
};
